import { ReactNode, useMemo } from 'react';

export interface StatusCardProps {
  children: ReactNode;
  noBottomPadding?: boolean;
}

const StatusCard: React.FunctionComponent<StatusCardProps> = function ({
  children,
  noBottomPadding = false,
}) {
  const className = useMemo(
    () =>
      [
        'flex flex-col flex-1 border border-neutral-300 rounded-xl bg-neutral-000 md:shadow-lg',
        noBottomPadding ? 'p-4 pb-0 md:p-6 md:pb-2' : 'p-4 md:p-6',
      ].join(' '),
    [noBottomPadding],
  );
  return <div className={className}>{children}</div>;
};

export default StatusCard;
